import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import CLOSE from "../../../../assets/images/icons/close.svg";
import Input from "../../../inputs/inputs";
import Button from "../../../buttons/buttons";
import { Beat } from "../../../../plugins/spinners.plugin";
import {
  detachShipperDeliveryMode,
  showShipper,
} from "../../../../redux/shippers/shippersActions";

export default React.forwardRef(function DetachDeliveryMode(
  {
    visibility = false,
    disableClose = false,
    disableOpen = false,
    onOpen = () => { },
    onClose = () => { },
    shipper_id,
  },
  ref
) {
  // Ref handler
  React.useImperativeHandle(ref, () => ({
    open: () => openModal(),
    close: () => closeModal(),
    getDeliveryMode: (data) => insertDeliveryMode(data),
  }));

  const dispatch = useDispatch();
  let [isOpen, setIsOpen] = React.useState(visibility);
  // const [submitted, setSubmitted] = useState(false);
  const [deliveryMode, setDeliveryMode] = React.useState("");
  // const [input, setInput] = useState({
  //   service_area_id: "",
  //   charge: "",
  // });

  console.log('deliveryMode',deliveryMode);
  

  const { updating } = useSelector((state) => state.shipper);

  function closeModal() {
    !disableClose && setIsOpen(false);
    !disableClose && onClose();
  }

  function openModal() {
    !disableOpen && setIsOpen(true);
    !disableOpen && onOpen();
  }

  function insertDeliveryMode(data) {
    setDeliveryMode(data);
  }

  const handleSubmit = async () => {
    // setSubmitted(true);
    if (deliveryMode && deliveryMode.id) {
      await dispatch(
        detachShipperDeliveryMode({
          id: shipper_id,
          delivery_mode_id: deliveryMode.id,
        })
      );
      dispatch(showShipper(shipper_id));
      closeModal();
    }
  };
  return (
    <React.Fragment>
      {/* <Button.Primary
        type={"button"}
        title={"Attach Service Area"}
        onClick={openModal}
      /> */}

      <Transition appear show={visibility || isOpen} as={React.Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <div className="min-h-screen px-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay
                className="fixed inset-0"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
              />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-center justify-center min-h-full p-4 sm:p-0">
                <Transition.Child
                  as={React.Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="relative w-[629px] bg-white dark:bg-[#121212] rounded-sm px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:my-10 sm:max-w-lg sm:w-full sm:p-8">
                    <div>
                      <div className="sm:block absolute top-4 right-5">
                        <button
                          type="button"
                          className="bg-[#ffeae5] rounded-md  p-1 sm:p-3  "
                          onClick={closeModal}
                        >
                          <span className="sr-only">Close</span>
                          <img src={CLOSE} alt="close" className=" w-3 h-3" />
                        </button>
                      </div>
                      <div className="sm:flex">
                        <div className="text-left sm:text-left sm:px-8">
                          <Dialog.Title
                            as="p"
                            className="text-md font-medium text-[#717485] dark:text-white"
                          >
                            Detach Delivery Mode
                          </Dialog.Title>
                        </div>
                      </div>
                    </div>

                    <div className=" border-b-2 mt-4"></div>
                    <div className="mt-5 sm:mx-auto w-full p-4">
                      <form>
                        <div className="w-full">
                          <div>
                            <Input.Label
                              title={"Delivery Mode"}
                              htmlFor={"area"}
                              name={"area"}
                              disabled={true}
                              defaultValue={deliveryMode?.title}
                              placeholder={"Search Delivery Mode"}
                            />
                          </div>

                        </div>
                        <div className="mt-8 mb-3 text-center flex justify-center gap-5">
                          <Button.Primary
                            type={"button"}
                            disabled={updating}
                            title={updating ? <Beat /> : "Detach Delivery Mode"}
                            onClick={handleSubmit}
                          />
                        </div>
                      </form>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition>
    </React.Fragment>
  );
});
